module.exports = __webpack_public_path__ + "static/media/Stable.9e6eab3a.png";